import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductStockShipping extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStockShipping);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockShipping);
  }

  /**
   * Updates the stock & shipping display when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStockShipping = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newStockShipping = event.detail.data.html.querySelector('product-stock-shipping');

    if (!newStockShipping) return;

    morph(this, newStockShipping, { childrenOnly: true });
  };
}

if (!customElements.get('product-stock-shipping')) {
  customElements.define('product-stock-shipping', ProductStockShipping);
}
